/**
 * Class list for a Bad/Good verdict pill. Shared by the review composer
 * and the LangSmith upload dialog so the two verdict controls look alike.
 */
export function verdictPillClass(active: boolean, tone: 'bad' | 'good'): string {
  const base =
    'h-8 rounded-md px-3 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring motion-safe:transition-colors'
  if (!active) return `${base} border border-transparent bg-muted text-muted-foreground`
  return tone === 'bad'
    ? `${base} border border-destructive/30 bg-destructive/10 text-destructive`
    : `${base} border border-success/30 bg-success/10 text-success`
}
